<template>
  <div class="popup" v-if="is_login">
    <div class="popup_div cover_img">
      <i class="esc" @click="escFun"
        ><img src="@/assets/img/shutDown.png" alt=""
      /></i>
      <i class="logo" v-if="login_index !== 5 && login_index !== 6"
        ><img
          src="https://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/logo.jpg"
          alt=""
      /></i>
      <!-- 登录 -->
      <div class="login_div" v-if="login_index == 1">
        <div class="login_head flex_start">
          <span
            :class="{ selected: head_index == 1 }"
            @click.stop="head_index = 1"
            >验证码登录</span
          >
          <span
            :class="{ selected: head_index == 2 }"
            @click.stop="head_index = 2"
            >密码登录</span
          >
        </div>
        <!-- 错误提醒 -->
        <div class="flex_start error_div" v-if="error && error !== ''">
          <i><img src="@/assets/img/error_icon.png" alt="" /></i>
          {{ error }}
        </div>
        <!-- 短信登录 -->
        <div class="form_div" v-if="head_index == 1">
          <div class="input_li">
            <input
              class="phone"
              type="number"
              v-model="phone"
              placeholder="请输入手机号"
            />
          </div>
          <div class="flex_between sms input_li">
            <input
              class="sms_input"
              type="number"
              v-model="code_num"
              placeholder="手机验证码"
            />
            <button class="get_sms sent" v-if="code_countdown > 0">
              已发送{{ code_countdown }}s
            </button>
            <button class="get_sms" v-else @click.stop="getSms">
              获取验证码
            </button>
          </div>
        </div>
        <!-- 密码登录 -->
        <div class="form_div" v-if="head_index == 2">
          <div class="input_li">
            <input
              class="phone"
              type="number"
              placeholder="请输入手机号"
              v-model="phone"
            />
          </div>
          <div class="input_li">
            <input
              class="phone"
              type="password"
              placeholder="请输入密码"
              v-model="password"
            />
          </div>
        </div>
        <button class="login_button" @click.stop="login">登录</button>
        <div class="flex_end go_ul">
          <a href="javaScript:void(0)" @click.stop="login_index = 3"
            >免费注册</a
          >
          <a href="javaScript:void(0)" @click.stop="login_index = 2"
            >忘记密码</a
          >
        </div>
        <div class="wx_login flex_start">
          <span>其他登录方式：</span>
          <i @click.stop="getCode"><img src="@/assets/img/wx.png" alt="" /></i>
        </div>
      </div>

      <!-- 找回密码 -->
      <div class="login_div back" v-if="login_index == 2">
        <div class="login_head flex_start">
          <span>忘记密码</span>
        </div>
        <div class="form_div">
          <div class="input_li">
            <input
              class="phone"
              type="number"
              placeholder="请输入手机号"
              v-model="phone"
            />
          </div>
          <div class="input_li">
            <input
              class="phone"
              type="password"
              placeholder="请输入密码"
              v-model="password"
            />
          </div>
          <div class="input_li">
            <input
              class="phone"
              type="password"
              placeholder="请确认密码"
              v-model="confirmPassword"
            />
          </div>
          <div class="flex_between sms input_li">
            <input
              class="sms_input"
              type="number"
              v-model="code_num"
              placeholder="手机验证码"
            />
            <button class="get_sms sent" v-if="code_countdown > 0">
              已发送{{ code_countdown }}s
            </button>
            <button class="get_sms" v-else @click.stop="getSms">
              获取验证码
            </button>
          </div>
        </div>
        <button class="login_button" @click.stop="backFun">找回密码</button>
        <div class="go_login">
          <a href="javaScript:void(0)" @click.stop="login_index = 1"
            >返回登录</a
          >
        </div>
      </div>

      <!-- 注册 -->
      <div class="login_div back" v-if="login_index == 3">
        <div class="login_head flex_start">
          <span>欢迎注册麻醉眼界</span>
        </div>
        <div class="form_div registered">
          <div class="input_li">
            <input
              class="phone"
              type="text"
              placeholder="昵称"
              v-model="nickname"
            />
          </div>
          <div class="input_li">
            <input
              class="phone"
              type="text"
              placeholder="姓名"
              v-model="name"
            />
          </div>
          <div class="input_li">
            <input
              class="phone"
              type="text"
              placeholder="邮箱"
              v-model="email"
            />
          </div>
          <div class="input_li">
            <input
              class="phone"
              type="number"
              placeholder="手机号"
              v-model="phone"
            />
          </div>
          <div class="input_li">
            <input
              class="phone"
              type="text"
              placeholder="单位名称"
              v-model="unitName"
            />
          </div>
          <div class="input_li">
            <input
              class="phone"
              type="text"
              placeholder="职称"
              v-model="professor"
            />
          </div>
          <div class="input_li">
            <input
              class="phone"
              type="text"
              placeholder="科室"
              v-model="office"
            />
          </div>
        <div class="input_li">
           <span class="li_title">执医证:</span>
            <el-upload
                    class="avatar-uploader"
                    :action="URL + 'upload'"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="handleAvatarPreview">
                    <img v-if="cert" :src="cert" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
        </div>
          <div class="input_li">
            <input
              class="phone"
              type="password"
              placeholder="密码"
              v-model="password"
            />
          </div>
          <div class="input_li">
            <input
              class="phone"
              type="password"
              placeholder="确认密码"
              v-model="confirmPassword"
            />
          </div>
          <div class="input_li address_li">
            <input
              class="phone"
              type="text"
              placeholder="邮寄地址(选填)"
              v-model="address"
            />
          </div>
          <div class="input_li agreement_div flex_start address_tpst">
            我们将不定期为您送上《麻醉·眼界》杂志哦！
          </div>
          <div class="input_li">
            <input
              class="phone"
              type="text"
              placeholder="会员邀请码(选填)"
              v-model="inviteCode"
            />
          </div>

          <div class="flex_between sms input_li">
            <input
              class="sms_input"
              type="number"
              v-model="code_num"
              placeholder="手机验证码"
            />
            <button class="get_sms sent" v-if="code_countdown > 0">
              已发送{{ code_countdown }}s
            </button>
            <button class="get_sms" v-else @click.stop="getSms">
              获取验证码
            </button>
          </div>

          <div class="input_li agreement_div flex_start">
            <i
              class="agreement"
              :class="{ selected: is_agreement }"
              @click.stop="is_agreement = !is_agreement"
            >
            </i>
            我以完全阅读并同意
            <a href="javaScript:void(0)" @click.stop="privacyFun(1)"
              >《注册协议》</a
            >
            <a href="javaScript:void(0)" @click.stop="privacyFun(2)"
              >《隐私协议》</a
            >
          </div>
        </div>
        <button class="login_button" @click.stop="registeredFun">注册</button>
        <div class="go_login flex_center registered">
          已有账号，现在去
          <a href="javaScript:void(0)" @click.stop="login_index = 1">登录</a>
        </div>
      </div>

      <!-- 绑定手机 -->
      <div class="login_div back" v-if="login_index == 4">
        <div class="login_head flex_start">
          <span>绑定手机</span>
        </div>
        <div class="form_div">
          <div class="input_li">
            <input
              class="phone"
              type="number"
              placeholder="请输入手机号"
              v-model="phone"
            />
          </div>
          <div class="flex_between sms input_li">
            <input
              class="sms_input"
              type="number"
              v-model="code_num"
              placeholder="手机验证码"
            />
            <button class="get_sms sent" v-if="code_countdown > 0">
              已发送{{ code_countdown }}s
            </button>
            <button class="get_sms" v-else @click.stop="getSms">
              获取验证码
            </button>
          </div>
        </div>
        <button class="login_button" @click.stop="dinding">确认绑定</button>
      </div>
      <!-- 注册提示弹窗 -->
      <div class="successfully" v-if="login_index == 5">
        <h4 class="flex_center successfully_title">
          <i><img src="@/assets/img/successfully.png" alt="" /></i>
          恭喜注册成功!
        </h4>
        <div class="successfully_text">
          恭喜您注册成功“麻醉眼界”会员，您的手机即为您的登录账号
        </div>
        <div class="go_login flex_center registered">
          {{ returnNum }}s后跳转
          <a href="javaScript:void(0)" @click.stop="login_index = 1">登录</a>
        </div>
      </div>
      <!-- 修改提示弹窗 -->
      <div class="successfully" v-if="login_index == 6">
        <h4 class="flex_center successfully_title">
          <i><img src="@/assets/img/successfully.png" alt="" /></i>
          修改成功!
        </h4>
        <div class="go_login flex_center registered">
          {{ returnNum }}s后跳转
          <a href="javaScript:void(0)" @click.stop="login_index = 1">登录</a>
        </div>
      </div>

      <!-- 修改密码 -->
      <div class="login_div back" v-if="login_index == 7">
        <div class="login_head flex_start">
          <span>修改密码</span>
        </div>
        <div class="form_div">
          <div class="input_li">
            <input
              class="phone"
              type="number"
              placeholder="请输入手机号"
              v-model.trim="phone"
            />
          </div>
          <div class="input_li">
            <input
              class="phone"
              type="password"
              placeholder="请输入新密码"
              v-model.trim="password"
            />
          </div>
          <div class="input_li">
            <input
              class="phone"
              type="password"
              placeholder="请确认新密码"
              v-model.trim="confirmPassword"
            />
          </div>
          <div class="flex_between sms input_li">
            <input
              class="sms_input"
              type="number"
              v-model.trim="code_num"
              placeholder="手机验证码"
            />
            <button class="get_sms sent" v-if="code_countdown > 0">
              已发送{{ code_countdown }}s
            </button>
            <button class="get_sms" v-else @click.stop="getSms">
              获取验证码
            </button>
          </div>
        </div>
        <button class="login_button" @click.stop="modifyFun">确认修改</button>
      </div>
      <!-- 协议 -->
    </div>
  </div>
</template>

<script>
// import layer from "layui-layer";
export default {
  name: "popup",
  data() {
    return {
      head_index: 2, //登录方式 1验证码 2密码
      login_index: 1, //登录 类型1登录 2找回密码 3注册 4绑定手机 5注册提示 6修改提示 7修改密码
      URL: this.$URL,
      cert:"",//执医证
      phone: "", //手机号
      code_num: "", //验证码
      password: "", //密码
      confirmPassword: "", //确认密码

      nickname: "", //昵称
      name: "", //姓名
      unitName: "", //单位名称
      professor: "", //职称
      office: "", //科室
      inviteCode: "", //会员邀请码
      address: "", //邮寄地址
      email: "", //邮箱
      is_agreement: true, //是否同意协议

      returnNum: 0, //返回登录 倒计时
      code_countdown: 0, //验证码倒计时
      error: "", //错误提示
      is_login: false,
    };
  },
  mounted() {
    this.phone = this.$store.state.phone;
  },
  components: {},
  props: {
    // is_login: {
    //     type: Boolean,
    //     default: false
    // },
  },
  watch: {
    is_login: function (eve) {
      let that = this;
      if (eve == true) {
      }
    },
    head_index: function (eve) {
      this.error = "";
    },
    login_index: function (eve) {
      this.empty();
      if (eve == 5 || eve == 6) {
        this.returnFun();
      }
    },
    phone: function (eve) {
      this.$store.commit("setPhone", eve);
    }
  },
  methods: {
    handleAvatarPreview () {//开始上传
      layer.open({
        type: 2
        , content: '上传中'
      });
    },
    handleAvatarSuccess (res, file) {
      layer.closeAll();
      layer.open({
        content: "上传完成",
        time: true,
        skin: "msg"
      });
      this.cert = res.data;
    },
    dinding() {
      //绑定手机
      if (!this.validation()) {
        return false;
      }
      if (this.code_num == "" || !this.code_num) {
        layer.open({
          content: "请输入手机验证码",
          time: true,
          skin: "msg",
        });
        return false;
      }
      let that = this;
      this.$post("user_modify", {
        mobile: this.phone,
        code: this.code_num,
        member_id: this.USER().id,
      })
        .then((res) => {
          if (res.code == 200) {
            layer.open({
              content: "绑定成功！",
              time: 2,
              skin: "msg",
            });
            res.data.token = res.data.refresh_token;
            that.SET_USER(res.data);
            setTimeout(() => {
              that.is_login = false;
            }, 2000);
          }
        })
        .catch((res) => {
           
          layer.open({
            content: res.message,
            time: 1,
            skin: "msg",
          });
        });
    },
    getCode() {
      //获取微信登录
      this.$get("pc_code", {})
        .then((res) => {
          window.location.href = res.data.data;
        })
        .catch((res) => {
           
          layer.open({
            content: res.message,
            time: true,
            skin: "msg",
          });
        });
    },
    privacyFun(index) {
      this.$emit("privacyFun", index);
    },
    loginFun(index) {
      this.login_index = index;
      this.is_login = true;
      if(index == 3){
        console.log(this.$store.state.loginUser,'11111111');
        if(this.$store.state.loginUser){
          this.nickname = this.$store.state.loginUser.name
          this.name = this.$store.state.loginUser.realname
          this.unitName = this.$store.state.loginUser.company
          this.professor = this.$store.state.loginUser.professor
          this.office = this.$store.state.loginUser.office
          this.email = this.$store.state.loginUser.email
          this.cert = this.$store.state.loginUser.cert
          this.phone = this.$store.state.loginUser.mobile
          this.adress = this.$store.state.loginUser.adress
        }
      }
    },
    returnFun() {
      //返回登录倒计时方法
      let that = this;
      that.returnNum = 3;
      let retirnSte = setInterval(() => {
        that.returnNum--;
        if (that.returnNum <= 0) {
          clearInterval(retirnSte);
          that.login_index = 1;
        }
      }, 1000);
    },
    empty() {
      //清空数据
      this.code_num = "";
      this.password = "";
      this.code_countdown = 0;
      this.error = "";
      this.confirmPassword = "";
    },
    validation() {
      //验证信息
      this.error = "";
      if (this.phone == "" || !this.phone) {
        layer.open({
          content: "请输入手机号",
          time: true,
          skin: "msg",
        });
        return false;
      }
      if (!this.validationPhone(this.phone)) {
        layer.open({
          content: "请输入正确的手机号",
          time: true,
          skin: "msg",
        });
        return false;
      }
      // 注册
      if (this.login_index == 3) {
        if (this.nickname == "" || !this.nickname) {
          layer.open({
            content: "请输入昵称",
            time: true,
            skin: "msg",
          });
        
          return false;
        }
        if (this.email == "" || !this.email) {
          layer.open({
            content: "请输入邮箱",
            time: true,
            skin: "msg",
          });

          return false;
        }
        if (this.name == "" || !this.name) {
          layer.open({
            content: "请输入真实姓名",
            time: true,
            skin: "msg",
          });
        
          return false;
        }
        if (this.unitName == "" || !this.unitName) {
          layer.open({
            content: "请输入单位名称",
            time: true,
            skin: "msg",
          });
         

          return false;
        }
        if (this.professor == "" || !this.professor) {
          layer.open({
            content: "请输入职称",
            time: true,
            skin: "msg",
          });
          

          return false;
        }
        if (this.office == "" || !this.office) {
          layer.open({
            content: "请输入科室",
            time: true,
            skin: "msg",
          });
        
          return false;
        }
         if (this.cert == "" || !this.cert) {
          layer.open({
            content: " 请上传执医证",
            time: true,
            skin: "msg",
          });
        
          return false;
        }
        if (!this.is_agreement) {
          layer.open({
            content: "请阅读并同意《注册协议》《隐私协议》",
            time: true,
            skin: "msg",
          });
          
          return false;
        }
      }
      //登录
      if (this.login_index == 1) {
        if (this.head_index == 1) {
          if (this.code_num == "" || !this.code_num) {
            layer.open({
              content: "请输入手机验证码",
              time: true,
              skin: "msg",
            });
            return false;
          }
        }
        if (this.head_index == 2) {
          if (this.password == "" || !this.password) {
            layer.open({
              content: "请输入六位数密码",
              time: true,
              skin: "msg",
            });
        
            return false;
          }
        }
      }
      // 找回密码
      if (
        this.login_index == 2 ||
        this.login_index == 3 ||
        this.login_index == 7
      ) {
        if (this.password == "" || !this.password || this.password.length < 6) {
          layer.open({
            content: "请输入六位数新密码",
            time: true,
            skin: "msg",
          });

          return false;
        }
        if (this.confirmPassword == "" || !this.confirmPassword) {
          layer.open({
            content: "请输入确认新密码",
            time: true,
            skin: "msg",
          });
         
          return false;
        }
        if (this.confirmPassword !== this.password) {
          layer.open({
            content: "两次密码不一致",
            time: true,
            skin: "msg",
          });
         
          return false;
        }
        if (this.code_num == "" || !this.code_num) {
          layer.open({
            content: "请输入手机验证码",
            time: true,
            skin: "msg",
          });
          return false;
        }
      }

      return true;
    },
    registeredFun() {
      //注册
      if (!this.validation()) {
        return false;
      }
      let that = this;
      let data = {
        mobile: this.phone,
        password: this.password,
        repassword: this.confirmPassword,
        code: this.code_num,
        company: this.unitName ? this.unitName : "",
        username: this.nickname ? this.nickname : "",
        realname: this.name ? this.name : "",
        invite: this.inviteCode ? this.inviteCode : "",
        professor: this.professor ? this.professor : "",
        office: this.office ? this.office : "",
        address: this.address ? this.address : "",
        email: this.email ? this.email : "",
        cert:this.cert ? this.cert : "",
        check_status:0
      };
      this.$post("mobile_register", data)
        .then((res) => {
          if(that.$store.state.loginUser){
            layer.open({
              content: "重新提交成功",
              time: true,
              skin: "msg",
            });
            that.escFun();
          }else{
            layer.open({
              content: "注册成功",
              time: true,
              skin: "msg",
            });
            setTimeout(() => {
              that.login_index = 5;
            }, 1000);
          }
        })
        .catch((res) => {
          layer.open({
            content: res.message,
            time: true,
            skin: "msg",
          });
        });
    },
    //修改密码
    modifyFun() {
      if (!this.validation()) {
        return false;
      }
      let that = this;
      let data = {
        mobile: this.phone,
        password: this.password,
        repassword: this.confirmPassword,
        code: this.code_num,
      };
      this.$post("repassword", data)
        .then((res) => {
           
          res.data.token = res.data.refresh_token;
          that.SET_USER(res.data);
          layer.open({
            content: "修改成功",
            time: true,
            skin: "msg",
          });
          setTimeout(() => {
            that.is_login = false;
          }, 1000);
        })
        .catch((res) => {
           
          layer.open({
            content: res.message,
            time: true,
            skin: "msg",
          });
        });
    },
    backFun() {
      //找回密码
      if (!this.validation()) {
        return false;
      }
      let that = this;
      let data = {
        mobile: this.phone,
        password: this.password,
        repassword: this.confirmPassword,
        code: this.code_num,
      };
      this.$post("repassword", data)
        .then((res) => {
           

          layer.open({
            content: "修改成功",
            time: true,
            skin: "msg",
          });
          setTimeout(() => {
            that.login_index = 6;
          }, 1000);
        })
        .catch((res) => {
           
          layer.open({
            content: res.message,
            time: true,
            skin: "msg",
          });
        });
    },
    login() {
      //登录
      if (!this.validation()) {
        return false;
      }
      let that = this;
      let data = {
        mobile: this.phone,
      };
      if (this.login_index == 1 && this.head_index == 1) {
        //验证码登录
        data.code = this.code_num;
      }
      if (this.login_index == 1 && this.head_index == 2) {
        //账号登录
        data.password = this.password;
      }
      this.$post("mobile_login", data)
        .then((res) => {
          layer.open({
            content: "登录成功",
            time: true,
            skin: "msg",
          });
          this.SET_USER(res.data);
          setTimeout(() => {
            if (that.USER().unionid == "" || !that.USER().unionid) {
              layer.open({
                content: "亲，绑定微信后可以显示微信头像，现在就去绑定？",
                style:
                  "background-color:#fef0f0; color:#F56C6C;font-size:18px; border:none;", //自定风格
                btn: ["确定", "取消"],
                yes: function (index) {
                  layer.close(index);
                  that.$store.commit("setParsonalPath", "/my_setUp");
                  that.$router.replace({ path: "personal" });
                },
                no: function (index) {
                  layer.close(index);
                  that.escFun();
                },
              });
            } else {
              that.escFun();
            }
          }, 1000);
        })
        .catch((res) => {
           
          that.error = res.message;
        });
    },
    getSms() {
      //获取验证码
      if (this.phone == "" || !this.phone) {
        layer.open({
          content: "请输入手机号",
          time: true,
          skin: "msg",
        });
        return false;
      }
      if (!this.validationPhone(this.phone)) {
        layer.open({
          content: "请输入正确的手机号",
          time: true,
          skin: "msg",
        });
        return false;
      }
      let that = this;
      this.$post("code", {
        mobile: this.phone,
      })
        .then((res) => {
           
          layer.open({
            content: "发送成功，请注意查收！",
            time: true,
            skin: "msg",
          });
          that.code_countdown = 60;
          let code_set = setInterval(() => {
            that.code_countdown--;
            if (that.code_countdown <= 0) {
              clearInterval(code_set);
            }
          }, 1000);
        })
        .catch((res) => {
           
          layer.open({
            content: res.message,
            time: true,
            skin: "msg",
          });
        });
    },
    escFun() {
      //关闭登录
      this.$emit("getUser");
      this.is_login = false;
    },
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input_li .li_title {
  text-align: left;
  width: 9rem;
  white-space: nowrap;
  font-size: 1.4rem;
  color: #8f8383;
  height: 2.8rem;
  line-height: 2.8rem;
}
.avatar-uploader .el-upload {
    border: 1px dashed #dfdfdf;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    border: 1px solid #dfdfdf;
    color: #dfdfdf;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
.popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

.popup .popup_div {
  position: absolute;
  top: 50%;
  width: 380px;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.16);
  padding: 40px 40px;
}

.popup_div .esc {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 25px;
  cursor: pointer;
}

.popup_div .logo {
  width: 50%;
  /* margin: 10px auto; */
}

.login_div {
  padding: 35px 0 0 0;
}

.login_div .login_head {
  margin-bottom: 30px;
}

.login_div .login_head > span {
  padding: 0 5px;
  font-size: 20px;
  margin-right: 30px;
  cursor: pointer;
  color: #666;
}

.login_div .login_head > span.selected {
  color: #333;
  border-bottom: 2px solid #333;
}

.login_button {
  width: 100%;
  height: 49px;
  color: #fff;
  font-weight: bold;
  background: #f24d5b;
  border-radius: 4px;
  border: 0;
  font-size: 18px;
  cursor: pointer;
}

.go_ul {
  align-items: center;
  margin-top: 13px;
}

.go_ul > a {
  margin-left: 14px;
  font-size: 12px;
  color: #999;
}

.wx_login {
  align-items: center;
  margin-top: 20px;
}

.wx_login > span {
  font-size: 14px;
  color: #333;
  margin-right: 15px;
}

.wx_login > i {
  width: 28px;
  cursor: pointer;
}

.go_login {
  margin-top: 30px;
}

.go_login > a {
  font-size: 14px;
  color: #333;
}

.back .login_head span {
  color: #333;
  margin: 0;
}

/* 错误提醒 */
.error_div {
  height: 32px;
  border: 1px solid #ff934c;
  background: #fefcee;
  font-size: 12px;
  color: #333;
  padding: 0 12px;
  align-items: center;
  margin-bottom: 16px;
  line-height: 1em;
}

.error_div > i {
  width: 20px;
  margin-right: 7px;
}

/* 短信登录 */
.form_div.registered {
  max-height: 40vh;
  overflow-y: auto;
  margin-bottom: 10px;
}

.form_div .input_li {
  width: 100%;
  margin-bottom: 16px;
}

.form_div .input_li .phone {
  height: 44px;
  border: 1px solid #dfdfdf;
  padding: 0 16px;
  font-size: 12px;
  color: #333;
  width: calc(100% - 34px);
}

.form_div .input_li.sms .sms_input {
  width: calc(100% - 132px);
  padding: 0 16px;
  border: 1px solid #dfdfdf;
  height: 44px;
}

.form_div .input_li.sms .get_sms {
  width: 122px;
  height: 44px;
  background: #f24d5b;
  color: #fff;
  font-size: 12px;
  border: 0;
}

.form_div .input_li.sms .get_sms.sent {
  background: #bfbfbf;
}

/* 注册 */
.agreement_div {
  margin-bottom: 16px;
  font-size: 12px;
  color: #333;
}

.agreement_div > .agreement {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  border: 1px solid #f24d5b;
  align-items: center;
  position: relative;
  margin-right: 5px;
  cursor: pointer;
}

.agreement_div > .agreement.selected::after {
  position: absolute;
  content: "";
  top: 3px;
  left: 3px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #f24d5b;
}

.agreement_div > a {
  color: #f24d5b;
}

.registered {
  font-size: 14px;
  color: #999;
  margin-top: 14px;
}

.registered > a {
  color: #333;
  margin-left: 2px;
}

/* 微信登录 */
.wx_login {
  padding: 0;
}

.wx_login .login_head {
  margin: 0;
}

.wx_login .login_head > span {
  color: #333;
}

.wx_login .qrCode i {
  width: 202px;
}

.wx_login .slogan {
  margin-top: 8px;
  font-size: 14px;
  color: #333;
}

.wx_login .slogan > i {
  width: 20px;
  margin-right: 8px;
}

.wx_login .go_login a {
  text-decoration: underline;
}

/* 注册弹窗 */
.successfully .successfully_title {
  font-size: 20px;
  color: #333;
}

.successfully_title > i {
  width: 33px;
  margin-right: 13px;
}

.successfully .successfully_text {
  font-size: 14px;
  color: #333;
  margin-top: 18px;
}

.successfully .go_login {
  margin-top: 40px;
  font-size: 12px;
  color: #656565;
}

/* 协议弹窗 */
.privacy_popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.privacy_popup .privacy {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
}
.form_div .input_li.address_li {
  margin-bottom: 6px;
}
.form_div .input_li.address_tpst {
  color: #757575;
  margin-top: 0;
  padding-left: 16px;
  width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/assembly/Login.vue